import * as React from 'react';
import { ScrollProps } from './Scroll.types';
import { RootRef } from '@material-ui/core';
import { StyledScroll, StyledScrollBox } from './Scroll.style';

export const Scroll = React.forwardRef((props: ScrollProps, ref) => {
  const { children, maxHeight } = props;
  return <RootRef rootRef={ref as any}>
    <StyledScrollBox maxHeight={maxHeight}>
      <StyledScroll>{children}</StyledScroll>
    </StyledScrollBox>
  </RootRef>
});